import { bool, func, node } from 'prop-types';
import React from 'react';
import { GoPencil, GoReply } from 'react-icons/go';

import TimeStamp from '../../generic/TimeStamp';
import { commentShape, userShape } from '../../prop-types';
import UserLink from '../../users/UserLink';
import storedUserInfo from '../../utils/session-data/user-info';

function CommentHeader({
  model: { created, senderId },
  withReplyToggle,
  sender,
  onEdit,
  onReply,
  children,
}) {
  const currentUser = storedUserInfo.get();
  const isOwner = senderId === currentUser.id;

  return (
    <div className="clearfix small">
      <span className="comment_user">
        {isOwner ? 'You' : sender && <UserLink model={sender} />}
      </span>
      &nbsp;-&nbsp;
      <span className="text-muted">
        <TimeStamp>{created}</TimeStamp>
      </span>
      {children}
      <div className="float-right">
        {isOwner && onEdit && (
          <GoPencil onClick={onEdit} className="qa-edit-comment" />
        )}
        {withReplyToggle && (
          <GoReply onClick={onReply} className="qa-reply-comment ml-1" />
        )}
      </div>
    </div>
  );
}

CommentHeader.propTypes = {
  model: commentShape.isRequired,
  withReplyToggle: bool.isRequired,
  sender: userShape.isRequired,

  onEdit: func,
  onReply: func,
  children: node,
};

CommentHeader.defaultProps = {
  children: null,
  onEdit: undefined,
  onReply: undefined,
};

export default CommentHeader;
